<ng-container>
  <form [formGroup]="loanPartyForm">
    <div class="row align-items-baseline">
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'estClosingDate' | qaSlug">
        <label class="control-label">Estimated Closing Date</label>
        <p-datepicker
          styleClass="w-100"
          formControlName="estClosingDate"
          [minDate]="minDate()"
          [maxDate]="maxDate"
          [readonlyInput]="false"
          [required]="false"
          [showIcon]="true"
          placeholder="MM/DD/YYYY"
          cmg-input-error
          errorControl="p-datepicker"
          errorEvent="onClickOutside"
          cmg-date-mask
          appendTo="body"
          id="estClosingDate"
          [baseZIndex]="dateTimePickerCalendarZIndex"
        />
      </div>
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'schedFundingDate' | qaSlug">
        <label class="control-label">Estimated Funding Date</label>
        <p-datepicker
          styleClass="w-100"
          formControlName="schedFundingDate"
          [minDate]="minDate()"
          [maxDate]="maxDate"
          [showIcon]="true"
          placeholder="MM/DD/YYYY"
          cmg-input-error
          errorControl="p-datepicker"
          errorEvent="onClickOutside"
          cmg-date-mask
          id="schedFundingDate"
          [baseZIndex]="dateTimePickerCalendarZIndex"
          appendTo="body"
        />
      </div>
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'firstPaymentDate' | qaSlug">
        <label class="control-label">First Payment Date</label>
        <p-datepicker
          styleClass="w-100"
          formControlName="firstPaymentDate"
          [minDate]="minDate()"
          [maxDate]="maxDate"
          [showIcon]="true"
          placeholder="MM/DD/YYYY"
          cmg-input-error
          errorControl="p-datepicker"
          errorEvent="onClickOutside"
          cmg-date-mask
          id="firstPaymentDate"
          [baseZIndex]="dateTimePickerCalendarZIndex"
          appendTo="body"
        />
      </div>
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'signingDate' | qaSlug">
        <label class="control-label">Signing Date</label>
        <p-datepicker
          styleClass="w-100"
          formControlName="signingDate"
          [maxDate]="maxDate"
          [readonlyInput]="false"
          [required]="false"
          [showIcon]="true"
          placeholder="MM/DD/YYYY"
          cmg-input-error
          errorControl="p-datepicker"
          errorEvent="onClickOutside"
          appendTo="body"
          cmg-date-mask
          id="signingDate"
          [baseZIndex]="dateTimePickerCalendarZIndex"
        />
      </div>
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'signingTime' | qaSlug">
        <label class="control-label">Signing Time</label>
        <input class="txt-box form-control" pInputText formControlName="signingTime" id="signingTime" />
      </div>
    </div>
    <hr />
    <div class="row align-items-baseline">
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'processor' | qaSlug">
        <label class="control-label">Processor</label>
        <p-select
          id="processor"
          class="w-100"
          formControlName="processor"
          [options]="loanProcessorList"
          [optionLabel]="'fullname'"
          [optionValue]="'username'"
          placeholder="Select"
          appendTo="body"
          [virtualScroll]="true"
          [filter]="true"
          virtualScrollItemSize="30"
        />
      </div>
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'productionAssistant' | qaSlug">
        <label class="control-label">Production Assistant</label>
        <p-select
          id="productionAssistant"
          class="w-100"
          formControlName="productionAssistant"
          [options]="productionAssistantList"
          [optionLabel]="'fullname'"
          [optionValue]="'username'"
          placeholder="Select"
          appendTo="body"
          [virtualScroll]="true"
          [filter]="true"
          virtualScrollItemSize="30"
        />
      </div>
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'originator' | qaSlug">
        <label class="control-label">Originator<span class="color-danger">*</span></label>
        <input class="txt-box form-control" pInputText formControlName="originator" maxlength="50" />
      </div>
    </div>
    <div class="row align-items-baseline">
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'addlprdoassistant' | qaSlug">
        <label class="control-label">Add'l Prod Assistant</label>
        <p-select
          id="addlProdAssistant"
          class="w-100"
          formControlName="addlProdAssistant"
          [options]="addlProdAssistantsList"
          [optionLabel]="'name'"
          [optionValue]="'value'"
          placeholder="Select"
          appendTo="body"
          [virtualScroll]="true"
          [filter]="true"
          virtualScrollItemSize="30"
        />
      </div>
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mb-2" [attr.automation-id]="'addlprdoassistant2' | qaSlug">
        <label class="control-label">Add'l Prod Assistant 2</label>
        <p-select
          id="addlProdAssistant2"
          class="w-100"
          formControlName="addlProdAssistant2"
          [options]="addlProdAssistants2List"
          [optionLabel]="'name'"
          [optionValue]="'value'"
          placeholder="Select"
          appendTo="body"
          [virtualScroll]="true"
          [filter]="true"
          virtualScrollItemSize="30"
        />
      </div>
    </div>
  </form>
</ng-container>
